import React from 'react'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../ui/sheet'
import { Download, Loader2, QuoteIcon, Paperclip } from 'lucide-react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { useMutation } from 'react-query'
import axios from 'src/axios/axios'
import { downloadFile } from 'src/functions/actions/documents'
import toast from 'react-hot-toast'
import { YYYYMMDDtoDate } from 'src/functions/format'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

type Props = {
    remarks?: Remark[]
    token?: string
}

const Remarks = ({remarks, token}:Props) => {
    const { t, i18n } = useTranslation()

  return (
    <Sheet>
        <SheetTrigger asChild><button className='w-10 h-10 flex justify-center items-center rounded-full bg-white hover:bg-slate-200'><QuoteIcon className='w-5 text-slate-500'/></button></SheetTrigger>
        <SheetContent className='md:max-w-[600px] md:w-full'>
            <SheetTitle>{t('Opmerkingen')}</SheetTitle>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>{t('Gebruiker')}</TableHead>
                        <TableHead>{t('Opmerking')}</TableHead>
                        <TableHead>{t('Datum toegevoegd')}</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array.isArray(remarks) && remarks.map((remark,i)=>(
                        <TableRow key={i}>
                            <TableCell>{remark.useradded}</TableCell>
                            <TableCell>{remark.remark}</TableCell>
                            <TableCell>{YYYYMMDDtoDate(remark.dateadded) ? format(YYYYMMDDtoDate(remark.dateadded), 'dd/MM/yyyy') : ''}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </SheetContent>
    </Sheet>
  )
}

export default Remarks